export default __webpack_public_path__ + "static/coding-16cfe35adf3fca85923eb8488fd05313.jpeg";